import { render, staticRenderFns } from "./LogoContainer.vue?vue&type=template&id=07d0a437&scoped=true&"
import script from "./LogoContainer.vue?vue&type=script&lang=js&"
export * from "./LogoContainer.vue?vue&type=script&lang=js&"
import style0 from "./LogoContainer.vue?vue&type=style&index=0&id=07d0a437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0a437",
  null
  
)

export default component.exports